import { useFrame } from '@react-three/fiber'
import { FunctionComponent } from 'react'

interface ForceHierarchyUpdateProps {

}

const ForceHierarchyUpdate: FunctionComponent<ForceHierarchyUpdateProps> = () => {
  useFrame((_state, _deltaTime) => {
    _state.scene.updateMatrixWorld(true)
  })

  return null
}

export default ForceHierarchyUpdate
